import { render, staticRenderFns } from "./SolicitacoesDeAbonos.vue?vue&type=template&id=27d4e1dc"
import script from "./SolicitacoesDeAbonos.vue?vue&type=script&lang=js"
export * from "./SolicitacoesDeAbonos.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesDeAbonos.vue?vue&type=style&index=0&id=27d4e1dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports